import React from 'react';
import { Connect, PropsFromRedux } from './RestrictToEnterpriseContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { JuridictionsChartContainer } from '../../../../../entity/charts/juridictions/JuridictionsChartContainer';
import { JuridictionsChart } from '../../../../../entity/charts/juridictions/JuridictionsChart';
import { UserContextType } from '../../../../../user/user.types';
import { withUser } from '../../../../../user/UserContext';
import { EnhanceJuridictionChart } from '../../../../../entity/charts/juridictions/EnhanceJuridictionChart';
import { ChartDecisionLegend } from '../../../../../entity/charts/legend/ChartLegend';
import { Juridiction } from '../../../../../entity/entity.types';

type Props = {
  enterpriseId: string;
  raisonSociale: string;
  url: string;
  source: string;
  juridictions: Array<any>;
} & PropsFromRedux &
  UserContextType &
  WithRestrictedModalProps;

class RawJuridictionTab extends React.Component<Props> {
  goToPage = (source: string) => () => {
    const clickedSource = `${this.props.source}-${source}`;
    if (this.props.accessPremium) {
      window.location.href = `${this.props.url}?source=${clickedSource}`;
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  filterSearch = (source: string) => (
    wantToOpenInNewTab: boolean,
    juridiction: Juridiction | null,
  ) => {
    const clickedSource = `${this.props.source}-${source}`;
    if (this.props.accessPremium) {
      const data = {
        enterpriseId: this.props.enterpriseId,
        raisonSociale: this.props.raisonSociale,
        juridiction: juridiction ? juridiction.key : null,
        type: 'juridiction' as const,
      };
      doctrineAnalytics('Search ChartSnippetClicked', data);
      this.props.onRestrictToEnterprise(data);
    } else {
      this.props.openRestrictedModal(clickedSource);
    }
  };

  render() {
    return (
      <div className="enterprise-snippet__panel">
        <JuridictionsChartContainer juridictions={this.props.juridictions}>
          {({ sortedJuridictions }) => (
            <>
              <EnhanceJuridictionChart
                juridictions={sortedJuridictions}
                handleClick={this.filterSearch('juridictions_chart')}
              >
                {({ data, labels, handleClick }) => (
                  <JuridictionsChart
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                  />
                )}
              </EnhanceJuridictionChart>
              <EnhanceJuridictionChart
                juridictions={sortedJuridictions}
                handleClick={this.filterSearch('juridictions_legend')}
              >
                {({ data, labels, handleClick, baseH }) => (
                  <ChartDecisionLegend
                    data={data}
                    labels={labels}
                    handleClick={handleClick}
                    onSeeMoreClicked={this.goToPage('juridictions_more_legend')}
                    limit={3}
                    baseH={baseH}
                  />
                )}
              </EnhanceJuridictionChart>
            </>
          )}
        </JuridictionsChartContainer>
      </div>
    );
  }
}

export const JuridictionTab = withUser(
  withRestrictedModal(Connect(RawJuridictionTab)),
);
